import { Component,Input,OnInit } from '@angular/core';
import { UtilsService } from '../../../../services/utils.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss',
  imports : [
    CommonModule
  ]
})
export class SkeletonComponent implements OnInit {
  @Input() id: any;
  @Input() columns:any;
  @Input() component!:string
  @Input() paginator!:boolean;
  @Input() rowCount!:number;
  @Input() size!:any;
  @Input() breadcrumbList :any[] = [1,2,3]
  @Input() fieldType:string = 'all';
  @Input() ElementHeight!:any;
  @Input() type:any;
  @Input() condition!: string;
  rowsArray: any;
  steps = Array(1);

  constructor(
    private utilsService: UtilsService
  ){}

  ngOnInit():void{
    this.utilsService.loader.set(true);    
    this.rowsArray = Array.from({ length: this.rowCount || 6 }, (_, index) => ({
      id: index + 1,
      opacity: index < 3 ? 1 : Math.max(1 - (index - 3) * 0.3, 0),
      }));
  }

  ngOnDestroy(): void {
    this.utilsService.loader.set(false);
  }

}
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
  



